<!-- <app-module-error class="flex-fill" *ngIf="noPMLicense" [noPMLicense]="true"></app-module-error> -->
<div class="cards-container" #challengesContainer>
    <div [hidden]="!(hasActiveChallenges && isLoaderValid || hasPendingChallenges && isLoaderValid)">
        <div #header class="d-flex align-items-center flex-wrap justify-content-between challenge-header-container">
            <div class="d-flex align-items-center">
                <div>
                    <i>
                        <svg class="icon-16 cursor-pointer icon-black" [ngbPopover]="popRules" #p="ngbPopover"
                            [class.active]="p.isOpen()" placement="bottom-left bottom auto" container="body"
                            triggers="mouseenter:mouseleave" popoverClass="cxone-challenges-tooltip">
                            <use href="../App_Themes/clearview-default/icons/utility/error.svg#error"></use>
                        </svg>
                    </i>
                    <ng-template #popRules class="sol-modal-style">
                        <p class="m-0 modal-text"><span cvLocalizedText [langSection]="'Challenges'"
                                [langKey]="'Challege_Tooltip_Message'">Displays details for a one-on-one challenge that
                                begins 24 hours after it's created, or you're invited. Join by placing your bet/wager
                                and it is a winner takes all challenge.</span></p>
                    </ng-template>
                </div>
                <p class="rule">
                    <span cvLocalizedText [langSection]="'Challenges'" [langKey]="'Rules'">Rules</span>
                </p>
            </div>
            <div class="d-flex align-items-center flex-wrap">
                <sol-button variant="text" size="medium" class="link-text"
                    (onClick)="openHistoryModal()">{{historyLabel}}</sol-button>
                <sol-button variant="primary" size="medium" class="btn-create-challenge"
                    (onClick)="openCreateChallengeModal()"
                    [disabled]="isLoading && firstLoad">{{createLabel}}</sol-button>
            </div>
        </div>
    </div>
    <overlay-scrollbars
        [style.height]="!(hasActiveChallenges && isLoaderValid || hasPendingChallenges && isLoaderValid) ? '100%' : scrollSize+'px'"
        [options]="!(hasActiveChallenges && isLoaderValid || hasPendingChallenges && isLoaderValid) ? hiddenScrollOptions : scrollOptions"
        class="scrollbar" [ngClass]="{'small-scroll': isWidgetSmall}">
        <div class="error-container" *ngIf="showEmptyState">
            <svg class="empty-error-icon">
                <use href="../App_Themes/CXone/icons/empty.svg#empty"></use>
            </svg>
            <div class="cxone-error-text" cvLocalizedText [langSection]="'Error_Module'"
                [langKey]="'No_Challenges_Created_Yet'">No challenges created yet</div>
            <button class="cxone-btn btn-medium btn-primary cxone-button-text"><span cvLocalizedText
                    [langSection]="'Challenges'" [langKey]="'Create_Challenges'"
                    (click)="openCreateChallengeModal()">Create challenges</span></button>
        </div>
        <div class="main-card-container" *ngIf="!showEmptyState">
            <div *ngIf="challengeService.challenges">
                <!-- Pending challenges -->
                <div class="card-container"
                    *ngFor="let challenge of challengeService.challenges.pendingChallenges.Invitations">
                    <cxone-challenge-card [challenge]="challenge" challengeStatus="pending"></cxone-challenge-card>
                </div>
                <!-- Running challenges -->
                <div class="card-container"
                    *ngFor="let challenge of challengeService.challenges.activeChallenges.RunningChallenges">
                    <cxone-challenge-card [challenge]="challenge" challengeStatus="ongoing"></cxone-challenge-card>
                </div>
                <!-- Upcoming challenges -->
                <div class="card-container"
                    *ngFor="let challenge of challengeService.challenges.activeChallenges.UpcomingChallenges">
                    <cxone-challenge-card [challenge]="challenge" challengeStatus="upcoming"></cxone-challenge-card>
                </div>
            </div>
            <div *ngIf="challengeService.challenges">
                <div class="card-container" *ngFor="let challenge of endedChallenges">
                    <cxone-challenge-card [challenge]="challenge" challengeStatus="ended"></cxone-challenge-card>
                </div>
            </div>
        </div>
    </overlay-scrollbars>
</div>